import { risingCardMotion, type FlowThemeCardMotion } from '../../cardMotion';

/** Cards drift up and away like light rising into the sky. */
export const auroraCardMotion = (isMobile: boolean): FlowThemeCardMotion => risingCardMotion(isMobile, 40, 10);
